export default __webpack_public_path__ + "static/media/craif_logo_b.7ad11763.png";